import { EnvConfig, Media, useAuthentication } from '@gripp/shared-logic';
import { useEffect, useState } from 'react';
import { Text, View } from 'react-native';
import { filesSharedStyles } from './filesSharedStyles';

export const VideoPanel = ({ media }: { media: Media | null }) => {
  const authentication = useAuthentication();
  const [playbackUrl, setPlaybackUrl] = useState<string | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!media) return;

    setPlaybackUrl(null);
    setError(false);

    const videoApiUrl = `${EnvConfig.apiUrl}/video/${media.id}`;
    let cancelled = false;

    const headers: HeadersInit = {};
    if (authentication?.accessToken) {
      headers['Authorization'] = `Bearer ${authentication.accessToken}`;
    }

    fetch(videoApiUrl, { credentials: 'omit', headers })
      .then((res) => {
        if (!res.ok) return Promise.reject(new Error(`${res.status}`));
        return res.json();
      })
      .then((data: { downloadUrl?: string }) => {
        if (!cancelled && data.downloadUrl) {
          setPlaybackUrl(data.downloadUrl);
        } else if (!cancelled) {
          setError(true);
        }
      })
      .catch(() => {
        if (!cancelled) setError(true);
      });

    return () => {
      cancelled = true;
    };
  }, [media, authentication?.accessToken]);

  if (!media) return null;

  if (error) {
    return (
      <View style={filesSharedStyles.videoPanelCenter}>
        <Text>Video unavailable</Text>
      </View>
    );
  }

  if (!playbackUrl) {
    return (
      <View style={filesSharedStyles.videoPanelCenter}>
        <Text>Loading video...</Text>
      </View>
    );
  }

  return (
    <View style={filesSharedStyles.galleryPanel}>
      <video
        src={playbackUrl}
        controls
        autoPlay
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          backgroundColor: '#000',
        }}
      />
    </View>
  );
};
